import React, { useState, useEffect } from "react";

const AddedValuesList = ({
  addedValuesHeading = "Added Languages",
  addedValuesList, // [{name:"something", value:"something", metadata:{}}] // name to display, value can be ID or string
  primaryButton = "SAVE",
  secondaryButton = "CANCEL",
  onSave,
  enableSave,
  onClose,
  deleteCallback = () => {},
}) => {
  const [allAddedValuesList, setAllAddedValuesList] = useState(addedValuesList);
  const [deleteItem, setDeleteItem] = useState("");

  useEffect(() => {
    setAllAddedValuesList(addedValuesList);
  }, [addedValuesList]);

  useEffect(() => {
    const updatedValue = allAddedValuesList?.filter(
      (value) => value !== deleteItem
    );
    setAllAddedValuesList(updatedValue);
    deleteCallback(updatedValue, deleteItem);
  }, [deleteItem]);

  return (
    <div className="addedLanguagesWrapper">
      <div> {addedValuesHeading} </div>
      <hr />
      {allAddedValuesList?.map((langItem, index) => {
        return (
          <div className="langItemWrapper" key={index}>
            <div
              className="delete-icon"
              onClick={() => {
                setDeleteItem(langItem);
              }}
            >
              <i className="glyphicon glyphicon-minus"></i>
            </div>
            <div className="langItem"> {langItem.name}</div>
            <hr />
          </div>
        );
      })}
      {enableSave && (
        <div className="popupButtonsWrapper">
          <button
            className="saveBtn"
            onClick={() => {
              onSave(allAddedValuesList);
            }}
          >
            {primaryButton}
          </button>
          <div
            className="cancelBtn"
            onClick={() => {
              onClose();
            }}
          >
            {secondaryButton}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddedValuesList;
